<div class="flex h-full flex-col gap-3x3 bg-grey-white_smoke dark:bg-contrast-black">
    <div
        class="relative flex h-16 items-center justify-center bg-white font-semibold leading-7 text-black shadow dark:border-t dark:border-solid dark:border-contrast-yellow dark:bg-contrast-black dark:text-contrast-yellow">
        <ion-button
            class="pn-light:text-primary pn-app-light:text-primary absolute left-0 text-xs font-semibold normal-case text-secondary dark:text-contrast-yellow"
            [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
            (click)="redirectToPreviousPage()"
            fill="clear"
            size="small">
            <ion-icon
                class="h-3x3 w-4x1 text-base dark:filter-yellow"
                title="{{ 'LOCAL_BTN_BACK' | translate }}"
                src="{{ assetsPath$ | async }}/img/banner/banner-back-button.svg"
                >{{ 'LOCAL_BTN_BACK' | translate }}</ion-icon
            >
        </ion-button>

        <h1 class="m-0 block text-center text-base font-semibold leading-7 text-black dark:text-contrast-yellow">
            {{ 'MORE_MENU_INFO' | translate }}
        </h1>
    </div>
    <div
        class="flex flex-col gap-2x2 p-4 pb-5x3 pt-4x1 shadow"
        *ngIf="banner"
        [ngClass]="{
            'info bg-secondary text-white': infoStyle,
            'traffic-info bg-yellow-alert text-black': trafficInfoStyle,
            'warning bg-danger !text-black': warningStyle,
            '!border !border-solid !border-contrast-yellow !bg-contrast-black !text-contrast-yellow': highContrastStyle,
            'bg-white text-black': !infoStyle && !trafficInfoStyle && !warningStyle && !highContrastStyle
        }">
        <ion-icon
            class="h-6x2 w-6x2"
            src="{{ assetsPath$ | async }}/img/banner/banner-{{ banner?.type?.toLowerCase() }}{{
                highContrastStyle ? '-dark' : ''
            }}.svg"></ion-icon>

        <h2 class="mb-0 text-base font-bold leading-5">
            {{ banner.title }}
        </h2>

        <div class="text-base leading-5" [innerHTML]="renderedMarkdown(banner.description)"></div>
    </div>
</div>
